// extracted by mini-css-extract-plugin
export default {"container":"loggedInView_container__NSF5l","fullWidthContainer":"loggedInView_fullWidthContainer__+lB7+","backbuttonContainer":"loggedInView_backbuttonContainer__tknnw"};